import { DbSortOrder } from "src/models/common/TPESearchRequest";
import DASHBOARD_CONSTANTS from "../dashboardConstants";
import { OpenRequestsSearchRequest } from "src/models/dashboard/OpenRequest";

export function getTopOpenRequestsSearchPayload(): OpenRequestsSearchRequest {
    return {
        page: 1,
        pageSize: DASHBOARD_CONSTANTS.SMALL_PAGE_SIZE,
        sortField: DASHBOARD_CONSTANTS.OPEN_REQUEST_FIELDS.DUE_DATE.DB_FIELD,
        sortOrder: DbSortOrder.ASCENDING,
        status: DASHBOARD_CONSTANTS.ACTIVE_STATUS
    };
}

export function getAllRequestsSearchPayload(): OpenRequestsSearchRequest {
    return {
        page: 1,
        pageSize: DASHBOARD_CONSTANTS.DEFAULT_PAGE_SIZE,
        sortField: DASHBOARD_CONSTANTS.OPEN_REQUEST_FIELDS.DUE_DATE.DB_FIELD,
        sortOrder: DbSortOrder.ASCENDING
    };
}